import { render, staticRenderFns } from "./LanguageResources.vue?vue&type=template&id=a10f2cd6&scoped=true"
import script from "./LanguageResources.vue?vue&type=script&lang=js"
export * from "./LanguageResources.vue?vue&type=script&lang=js"
import style0 from "./LanguageResources.vue?vue&type=style&index=0&id=a10f2cd6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10f2cd6",
  null
  
)

export default component.exports